import React from "react";
import { Grid, Typography } from "@mui/material";
import dayjs from "dayjs";

import style from "./index.module.css";

import { storage } from "@/utils/Storage";

import { IRoleType } from "@/models/role";
import { ISessionKeys } from "@/models";

const CopyWriteFooter: React.FC = () => {
  const roleType = storage.getSessionToken(ISessionKeys.ROLE_TYPE);
  return (
    <Grid
      item
      className={style.container}
      sx={{
        backgroundColor:
          roleType === IRoleType.PATIENT ? "var(--gray-200)" : "white",
      }}
    >
      <Typography component={"p"}>
        © {dayjs().year()} Global Neuro and Spine Care. All Rights Reserved
      </Typography>
    </Grid>
  );
};

export default CopyWriteFooter;
